import { JRCAvatar, JRCAvatarProps } from 'jamespot-react-components';
import { Network } from 'jamespot-front-business';
import React from 'react';
import { useTheme } from 'styled-components';
import { commonComponentsRegistry } from '../registry/CommonRegistry';
import { useAppSelector } from '../redux/store';

const JRCIcon = commonComponentsRegistry.getLazyComponent('Icon');

const BASE_MULTIPLE = 8;

export const Avatar = (props: JRCAvatarProps) => {
    const theme = useTheme();
    const networkPublic = useAppSelector(Network.selectors.selectNetworkPublic);

    if (props.uri === networkPublic?.uri) {
        return (
            <JRCIcon
                name={'icon-fs-wall'}
                size={(props.size ?? 3) * BASE_MULTIPLE}
                color={theme.color.primary}
                variant={'circle'}
            />
        );
    }

    return <JRCAvatar {...props} />;
};
